export default {
    indexVacancyControl: { method: 'get',    url: 'ambience_links/vacancy_control' },
}